import {Component, store, constant} from 'Generic';
import {numberFormat, getTranslation, addCurrencySymbol} from 'Generic/lib';

export default class Addons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('#addons-wrapper'),
      state: store.state,
    });
  }

  render() {
    const {excludeAddonsOnTrial} = constant;
    const addonsToBeHideFromDisplay = constant.specialAddonList;
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const addonList = selectedPlan.addons ? selectedPlan.addons : [];
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    const disabledAddons = this.state.disable_addons ? this.state.disable_addons : [];
    const trialLength = Number(selectedPlan?.trial_length || 0);

    let addonsHtml = '';

    if (addonList.length) {
      for (const addon of addonList) {
        const addonTitle = getTranslation(addon.code);
        const addonPrice = numberFormat(Number(addon.unit_amount) / Number(selectedPlan.interval_length));

        const addonConditions =
          addon.state === 'active' && !addonsToBeHideFromDisplay.includes(addon.code) && addon.code !== this.state.pre_selected_addon;

        // For Trials remove Dedicated Server and Residential Network Addon
        const trialCondition = excludeAddonsOnTrial.includes(addon?.code) && trialLength > 0;
        if (trialCondition) {
          continue;
        }

        addonConditions &&
          (addonsHtml += `
            <div data-eventname="addon_visibility" data-eventtype="${addon.code}" data-eventtrigger="visible" class="addon-box">
              <div class="addon-container row">
                  <div class="col-xs-8 col-sm-8">
                      <span class="addon-label">
                          ${addonTitle}
                          <i class="popup_link" data-eventcategory ="Order Cart" data-eventaction="Addon information button click"  data-eventlabel="${
                            addon.code
                          }" data-eventvalue="1" addon-code="${addon.code}">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="test bi bi-info-circle-fill" viewBox="0 0 16 16">
                                  <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"></path>
                              </svg>
                          </i>
                      </span>
                  </div>
                  <div class="col-sm-4">
                    <span class="addon-label addon-price-span">
                      <i id="addon_ppm" class="addon-currency-text addon-price">${addCurrencySymbol(
                        addonPrice,
                      )}</i><span class="per-month">/${getTranslation('mo')}</span>
                      
                      </span>

                    <div class="addon-button-label">
                      <button type="button" class="addon-btn" addon-code="${addon.code}"
                      ${selectedAddons.includes(addon.code) && "style='display:none;'"}
                      ${disabledAddons.includes(addon.code) && 'disabled="disabled"'}
                      >
                        <span addon-code="${addon.code}" class="addon-name icon-plus"></span>
                      </button>
                      <div class="hide-img">
                        <span>${getTranslation('add_addon')}</span>
                      </div>
                    </div>

                    <div class="addon-button-label">
                      <button type="button" class="remove-btn"
                        addon-code="${addon.code}"
                        ${selectedAddons.includes(addon.code) && "style='display: inline-block;'"}
                        data-eventname="addon_remove"
                        data-eventtype="${addon.code}"
                        data-eventtrigger="click"
                      >
                        <span addon-code="${addon.code}" class="addon-name icon-check"></span>
                      </button>
                      <div class="hide-img">
                        <span span class="remove-addon-text">${getTranslation('remove_addon')}</span>
                      </div>
                    </div>

                  </div>
                </div>
            </div>
        `);

        /* Addons info popup add addon button handling */
        let addonInfoPopupWrapper = document.querySelector(`.addons-info-popups #${addon.code}_info_popup`);
        let addonInfoPopupAddBtn = addonInfoPopupWrapper ? addonInfoPopupWrapper.querySelector('.addon-modal-btn') : null;

        if (addonInfoPopupAddBtn) {
          let addonInfoPopupAddBtnDisplay = 'block';

          if ([...selectedAddons, ...disabledAddons].includes(addon.code)) {
            addonInfoPopupAddBtnDisplay = 'none';
          }

          addonInfoPopupAddBtn.style.display = addonInfoPopupAddBtnDisplay;
        }
      }
    }

    this.element.innerHTML = addonsHtml;
  }
}
